export default __webpack_public_path__ + "fonts/color_deign62.e09eebc49d2e101bbbe855ba0aacac79.png";